/// <reference path="../../global/fn.js" />

(function ($) {
    $.widget("nsp.w_membersCarousel", {
        options: {
            slickOptions:{
                arrows: false,
                autoplay: true,
                autoplaySpeed: 4000,
                infinite: true,
                slidesToShow: 5,
                slidesToScroll: 5,
                dots: true,
                rows: 0,
                pauseOnFocus: false, 
                pauseOnHover: false,
                responsive: [
                    {
                        breakpoint: api.vars.scr.tablet ,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2                          
                        },
                    }
                ],
            }
        },

        _create: function () {
            this.wrap = this.element;

            $('.s-members__carousel__items', this.wrap).each((indx, el)=>{                
                $(el).on('init', (slick)=>{
                    var dots = $('.slick-dots', $(slick.target))  
                    api.fn.slickDotsInit(dots, this.options.slickOptions.autoplaySpeed/1000)
                })
                .slick(this.options.slickOptions)
                .on('beforeChange', (event, slick, currentSlide, nextSlide)=>{
                    var dots = $('.slick-dots', $(event.target))
                    api.fn.slickDotsFilled(dots, nextSlide)
                })
            });
        }           

    });
})(jQuery);



